module.exports = __webpack_public_path__ + "media/audio49.9a475dba.mp3";